import { connect } from 'react-redux';
import { getTheme, getShowMatureContent, getIsLoggedIn, getCurrentUser, getPointsCount, getCsrfToken, getCurrentUserHasCore, getFeedbackUrl, getVerificationEmailAddress, getCanEnableToggleMatureContent, getThemeSkin, getCurrentUserHasWixPortfolio, getFragmentsBalance, getCoreLevel, getTierСount, } from '../publicSession/selectors';
import { toggleMature, toggleTheme, setTheme, setThemeSkin, } from '../publicSession/actions';
import { ModalType } from '../Modals/redux/types';
import { pushModal } from '../Modals/redux/basicActions';
import { userLogoutButtonClicked } from './redux/actions';
import { isPortfolioReduxReady } from '../WixPortfolio/redux/selectors';
import { flagEnabled } from '../redux/flags/selectors';
var mapStateToProps = function (state) { return ({
    csrfToken: getCsrfToken(state),
    currentUser: getCurrentUser(state),
    isLoggedIn: getIsLoggedIn(state),
    verificationEmail: getVerificationEmailAddress(state),
    theme: getTheme(state),
    themeSkin: getThemeSkin(state),
    matureContent: getShowMatureContent(state),
    pointsCount: getPointsCount(state),
    fragmentsBalance: getFragmentsBalance(state),
    hasCoreMembership: getCurrentUserHasCore(state),
    hasWixPortfolio: getCurrentUserHasWixPortfolio(state),
    coreLevel: getCoreLevel(state),
    feedbackUrl: getFeedbackUrl(state),
    canEnableMatureContent: getCanEnableToggleMatureContent(state),
    isPortfolioReduxReady: isPortfolioReduxReady(state),
    hasSubscriptions: getTierСount(state) > 0,
    isDSUserDropdown: flagEnabled(state, 'ds_user_dropdown'),
}); };
var mapDispatchToProps = {
    toggleTheme: toggleTheme,
    toggleMature: toggleMature,
    setTheme: setTheme,
    setThemeSkin: setThemeSkin,
    pushWixPortfolioModal: function () {
        return pushModal(ModalType.WIX_PORTFOLIO_CREATE, { wrapInModal: false });
    },
    onUserLogoutButtonClicked: userLogoutButtonClicked,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=UserMenu.container.js.map